import styled from 'styled-components';

export const Error = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 30%;
  height: 100%;
  background: #fff;
`;
